import React, { useState, useEffect } from "react";
import { Calendar } from "lucide-react";

const SkipDeliveryModal = ({
  isOpen,
  onClose,
  onConfirm,
  deliveryDate,
  isSubmitting = false,
}) => {
  const [skipReason, setSkipReason] = useState("");

  // Reset reason when modal opens/closes
  useEffect(() => {
    if (!isOpen) {
      setSkipReason("");
    }
  }, [isOpen]);

  const handleConfirm = () => {
    onConfirm(skipReason);
  };

  const handleClose = () => {
    setSkipReason("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg max-w-md w-full mx-4">
        <div className="bg-hf-gradient rounded-t-lg px-6 py-4 text-center">
          <h3 className="text-xl font-bold text-white">Skip Delivery?</h3>
        </div>
        <div className="p-6">
          <div className="flex flex-col items-center gap-3 mb-4">
            <Calendar className="w-11 h-11 text-amber-600" />
          </div>

          {deliveryDate && (
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
              <p className="text-sm text-gray-600 mb-1">Delivery Date:</p>
              <p className="text-lg font-semibold text-primary-text">
                {deliveryDate}
              </p>
            </div>
          )}

          <p className="text-gray-600 mb-4">
            Are you sure you want to skip this delivery? Your subscription will
            continue with the next scheduled delivery.
          </p>

          <div className="mb-6">
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Reason for skipping (Optional):
            </label>
            <textarea
              value={skipReason}
              onChange={(e) => setSkipReason(e.target.value)}
              placeholder="Enter your reason here..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-100 resize-none"
              rows={4}
              disabled={isSubmitting}
            />
          </div>

          <div className="flex gap-3">
            <button
              onClick={handleClose}
              disabled={isSubmitting}
              className="flex-1 px-4 py-2.5 bg-primary-100 text-white border-2 rounded-lg font-semibold hover:bg-red-700 transition-colors disabled:opacity-50"
            >
              No, Keep It
            </button>
            <button
              onClick={handleConfirm}
              disabled={isSubmitting}
              className="flex-1 px-4 py-2.5 border-2 border-gray-400 text-gray-400 rounded-lg font-semibold hover:bg-gray-300 hover:text-black transition-colors disabled:opacity-50"
            >
              {isSubmitting ? "Skipping..." : "Yes, Skip"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkipDeliveryModal;
